import React, { useMemo, useState } from "react";
import axios from "axios";
import { CloseIconSmall } from "@kursk/components/ui/icons";
import { api, paramsSerializer, paramsToQuery } from "@common/urls";
import { Carousel, ICarouselOptions } from '@kursk/components/ui/Carousel/Carousel';
import { useOrientations } from "@common/hooks/useOrientation";
import { ButtonGroup } from "./ButtonGroup/ButtonGroup";
import { IPointProps } from "@common/redux/types/map";
import { MapComponent } from "./MapComponent/MapComponent";
import { MapEntityCard } from "./MapEntityCard/MapEntityCard";
import { regionContent } from "@kursk/content/regionContent";
import classNames from "classnames";
import styles from './MapForCatalog.module.scss';

const options: ICarouselOptions = {
  swipeable: true,
  infinite: false,
  renderButtonGroupOutside: true,
  partialVisible: true,
  sliderClass: styles.carouselTrack
};

export const MapForCatalog = ({ items, entityType }) => {
  const orientation = useOrientations();

  const [balloonIsOpen, setBalloonIsOpen] = useState(false);
  const [balloonIsLoading, setBalloonIsLoading] = useState(false);
  const [balloonItems, setBalloonItems] = useState([]);

  const mapPoints = useMemo(() => {
    return items.map((point, index): IPointProps => ({
      coords: point.point,
      id: point._id.toString() + index,
      entityId: point._id.toString(),
      type: point.type,
      content: index + 1,
    }))
  }, [items]);

  const loadEntityItemsData = async (geoObjects) => {
    const schedules = geoObjects.filter(obj => obj.properties.pointType === "schedules")
    const seances = geoObjects.filter(obj => obj.properties.pointType === "seances")
    const places = geoObjects.filter(obj => obj.properties.pointType === "places")
    const ticketsbundles = geoObjects.filter(obj => obj.properties.pointType === "ticketsbundles")


    const response = await axios.get(
      api.mapPoints.getOne(),
      {
        params: paramsToQuery({
          schedules: schedules.length > 0 ? schedules.map(obj => obj.properties.entityId).join(',') : null,
          seances: seances.length > 0 ? seances.map(obj => obj.properties.entityId).join(',') : null,
          places: places.length > 0 ? places.map(obj => obj.properties.entityId).join(',') : null,
          ticketsbundles: ticketsbundles.length > 0 ? ticketsbundles.map(obj => obj.properties.entityId).join(',')
            : null,
        }),
        paramsSerializer
      }
    );

    return response.data.map((dataItem) => ({ ...dataItem, entityType }));
  };

  const onCloseBalloonClick = () => {
    setBalloonIsOpen(false);
    setBalloonItems([]);
  };

  const onPinClick = async (geoObjects) => {
    setBalloonIsLoading(true);
    setBalloonIsOpen(true);

    const entityItems = await loadEntityItemsData(geoObjects);

    setBalloonItems(entityItems);
    setBalloonIsLoading(false);
  };

  const yanMap = useMemo(() => {
    return (
      <MapComponent
        height={orientation !== "mobile" ? 600 : 650}
        points={mapPoints}
        mapState={regionContent.yandexMapState}
        handleOnPinClick={onPinClick}
        balloonIsOpen={balloonIsOpen}
        closeBalloon={onCloseBalloonClick}
      />
    );
  }, [mapPoints, balloonIsOpen])

  return (
    <section className={styles.section_map}>
      <div className={styles.mapWrapper}>
        {yanMap}
        {balloonIsOpen && (
          <div
            className={classNames(
              [styles.balloonWrapper, balloonItems.length > 1 && styles.balloonWrapperWithCarousel]
            )}
          >
            <div className={styles.balloonClose} onClick={onCloseBalloonClick}>
              <CloseIconSmall />
            </div>
            {balloonIsLoading && (
              <div className={styles.balloonLoader}>
                <img src='/images/balloonLoader.gif'/>
              </div>
            )}
            {!balloonIsLoading && (
              <>
                {balloonItems.length === 1 ? (
                  <MapEntityCard entity={balloonItems[0]} entityType={balloonItems[0].type} />
                ) : (
                  <>
                    <Carousel
                      Buttons={<ButtonGroup totalItems={balloonItems.length}/>}
                      carouselOptions={options}
                    >
                      {balloonItems.map((item) => (
                        <MapEntityCard key={item._id} entity={item} entityType={item.type} />
                      ))}
                    </Carousel>
                  </>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </section>
  )
}
